import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { FC } from 'react';

import { Property } from 'shared-types/Property';

import { SignIn as SignInV1 } from './containers';
import { SignInV2 } from './v2';

type SignInVersionProps = {
  language: string;
  property: Property;
};

export const SignInVersion: FC<SignInVersionProps> = ({ language, property }) => {
  const isV2 = useFeatureIsOn('feature.ecom2');
  if (isV2) return <SignInV2 language={language} property={property} />;
  return <SignInV1 language={language} propertyId={property.id} />;
};
